import Vue from 'vue'
import bySrore from 'biyi-store'
import iView from 'view-design'
import 'view-design/dist/styles/iview.css'
import App from './app.vue'
import util from './libs/util'
import router from './router/router'
import  moment from 'moment'
import store from './store/store'
import VueI18n from 'vue-i18n'
import localeI18n from './i18n/index'
import { ButtonLimited } from 'biyi-admin'
import { Tree,Loading,Drawer,Switch} from 'element-ui'
import dict from '@/plugin/dict'
import { getDict } from '@/api/cms/app'

// 将自动注册所有组件为全局组件
import dataV from "@jiaminghi/data-view";

Vue.use(dataV);

Vue.config.productionTip = false
Vue.prototype.$util = util
Vue.prototype.$http = util.http
Vue.prototype.$moment = moment
// console.log(getDict,'getDict')
Vue.prototype.$getDict = getDict

dict.install(Vue)
Vue.use(bySrore)
Vue.use(VueI18n)
Vue.use(Tree)
Vue.use(iView, {
  i18n: function (path, options) {
    let value = i18n.t(path, options)
    if (value !== null && value !== undefined) {
      return value
    }
    return ''
  }
})

Vue.component('Button', ButtonLimited)
Vue.component(Drawer.name, Drawer)
Vue.component(Switch.name, Switch)

Vue.locale = () => {}
Vue.prototype.$loading =  Loading.service
Vue.use(Loading.directive)
Vue.use(Loading)

const i18n = new VueI18n(localeI18n)

const vm = new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')

export default vm
